import {
  SCREEN_TYPE_MEMBER_HOME,
  SCREEN_TYPE_YOGA_HOME,
  SCREEN_TYPE_CENTERS,
  SCREEN_TYPE_EVENTS_PLUS,
  SCREEN_TYPE_AMA_EVENTS,
} from 'services/page-manager/entities'

/**
 * Page manager screen type for member home
 */
export const PM_SCREEN_TYPE_MEMBER_HOME = SCREEN_TYPE_MEMBER_HOME

/**
 * Page manager screen type for yoga
 */
export const PM_SCREEN_TYPE_YOGA_HOME = SCREEN_TYPE_YOGA_HOME

/**
 * Page manager screen type for centers
 */
export const PM_SCREEN_TYPE_CENTERS = SCREEN_TYPE_CENTERS

/**
 * Page manager screen type for centers
 */
export const PM_SCREEN_TYPE_EVENTS_PLUS = SCREEN_TYPE_EVENTS_PLUS

/**
 * Page manager screen type for AMA events
 */
export const PM_SCREEN_TYPE_AMA_EVENTS = SCREEN_TYPE_AMA_EVENTS
